module.exports = __webpack_public_path__ + "static/media/cu-housing.a12edbb7.jpg";